export const BRAINTREE_PAYMENT_METHOD = {
  CREDIT_CARD: "CreditCard",
  PAYPAL: "PayPalAccount",
};
